import React from "react";
import WeatherApp from "./Components/WeatherApp";

function App() {
  return <WeatherApp />;
}

export default App;
